import { shouldUseWebGpsPolling } from "./nativeTracking";

function toBearer(token) {
  const t = String(token || "").trim();
  if (!t) return "";
  return /^bearer\s+/i.test(t) ? t : `Bearer ${t}`;
}

export function pingOrderGps(orderId, token, reason = "stage") {
  try {
    const id = String(orderId || "").trim();
    if (!id || !token) return;
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const c = pos?.coords || {};
        const body = {
          lat: c.latitude,
          lng: c.longitude,
          accuracy: c.accuracy ?? null,
          speed: c.speed ?? null,
          heading: c.heading ?? null,
          at: pos?.timestamp ?? null,
          reason,
        };

        fetch(`/api/driver/order/${encodeURIComponent(id)}/gps`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: toBearer(token),
          },
          credentials: "include",
          body: JSON.stringify(body),
        }).catch(() => {});
      },
      () => {},
      {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 15 * 1000,
      }
    );
  } catch {
    // silent
  }
}

let __gpsTimer = null;
let __gpsOrderId = null;

export function startPeriodicOrderGps(orderId, token, intervalSec = 30) {
  try {
    if (!shouldUseWebGpsPolling()) {
      stopPeriodicOrderGps();
      return;
    }

    const id = String(orderId || "").trim();
    if (!id || !token) return;

    const sec = Math.max(10, Math.min(300, Number(intervalSec) || 30));

    if (__gpsTimer && __gpsOrderId === id) return;

    stopPeriodicOrderGps();
    __gpsOrderId = id;

    pingOrderGps(id, token, "tick_start");

    __gpsTimer = setInterval(() => {
      pingOrderGps(id, token, "tick");
    }, sec * 1000);
  } catch {
    // silent
  }
}

export function stopPeriodicOrderGps() {
  try {
    if (__gpsTimer) clearInterval(__gpsTimer);
  } catch {
    // silent
  } finally {
    __gpsTimer = null;
    __gpsOrderId = null;
  }
}

export function syncPeriodicOrderGpsForOrders(orders, token, intervalSec = 30) {
  try {
    if (!shouldUseWebGpsPolling()) {
      stopPeriodicOrderGps();
      return;
    }

    const list = Array.isArray(orders) ? orders : [];
    if (!token) return;

    const trackStatuses = new Set(["ON_ROUTE", "AT_PICKUP", "LOADED"]);
    const active =
      list.find((o) => trackStatuses.has(String(o?.status || "").toUpperCase())) || null;

    const oid = String(active?.id || active?._id || active?.orderId || "").trim();

    if (oid) startPeriodicOrderGps(oid, token, intervalSec);
    else stopPeriodicOrderGps();
  } catch {
    // silent
  }
}
